import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", consent: false });
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!values.name.trim() || values.name.trim().length < 2) {
      nextErrors.name = t("newsletter.errors.name_required");
    }
    if (!EMAIL_REGEX.test(values.email.trim())) {
      nextErrors.email = t("newsletter.errors.email_required");
    }
    if (!values.consent) {
      nextErrors.consent = t("newsletter.errors.consent_required");
    }
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    try {
      const stored = JSON.parse(localStorage.getItem("urkoza_leads") || "[]");
      stored.push({
        name: values.name.trim(),
        email: values.email.trim(),
        createdAt: new Date().toISOString(),
      });
      localStorage.setItem("urkoza_leads", JSON.stringify(stored));
    } catch {
      /* noop */
    }

    navigate("/thank_you");
  };

  return (
    <form
      className="grid gap-4"
      onSubmit={handleSubmit}
      noValidate
      data-testid="newsletter-form"
    >
      <div>
        <label
          htmlFor="newsletter-name"
          className="block text-sm font-medium text-[#0E2A47]"
        >
          {t("newsletter.name_label")}
        </label>
        <input
          id="newsletter-name"
          type="text"
          autoComplete="name"
          value={values.name}
          onChange={(e) => setValues((v) => ({ ...v, name: e.target.value }))}
          placeholder={t("newsletter.name_placeholder")}
          className="mt-2 w-full rounded-lg border border-[#0E2A47]/20 bg-white px-4 py-3 text-[#0E2A47] placeholder-[#0E2A47]/40 focus:outline-none focus:ring-2 focus:ring-[#0F5F3F]/40 focus:border-[#0F5F3F]"
          data-testid="newsletter-name-input"
          aria-invalid={!!errors.name}
        />
        {errors.name && (
          <p className="mt-1 text-sm text-[#C8102E]" data-testid="newsletter-name-error">
            {errors.name}
          </p>
        )}
      </div>

      <div>
        <label
          htmlFor="newsletter-email"
          className="block text-sm font-medium text-[#0E2A47]"
        >
          {t("newsletter.email_label")}
        </label>
        <input
          id="newsletter-email"
          type="email"
          autoComplete="email"
          value={values.email}
          onChange={(e) => setValues((v) => ({ ...v, email: e.target.value }))}
          placeholder={t("newsletter.email_placeholder")}
          className="mt-2 w-full rounded-lg border border-[#0E2A47]/20 bg-white px-4 py-3 text-[#0E2A47] placeholder-[#0E2A47]/40 focus:outline-none focus:ring-2 focus:ring-[#0F5F3F]/40 focus:border-[#0F5F3F]"
          data-testid="newsletter-email-input"
          aria-invalid={!!errors.email}
        />
        {errors.email && (
          <p className="mt-1 text-sm text-[#C8102E]" data-testid="newsletter-email-error">
            {errors.email}
          </p>
        )}
      </div>

      <label className="flex items-start gap-3 text-sm text-[#0E2A47]/80">
        <input
          type="checkbox"
          checked={values.consent}
          onChange={(e) => setValues((v) => ({ ...v, consent: e.target.checked }))}
          className="mt-1 h-4 w-4 accent-[#0F5F3F]"
          data-testid="newsletter-consent-checkbox"
        />
        <span>{t("newsletter.consent")}</span>
      </label>
      {errors.consent && (
        <p className="-mt-2 text-sm text-[#C8102E]" data-testid="newsletter-consent-error">
          {errors.consent}
        </p>
      )}

      <button
        type="submit"
        className="mt-1 inline-flex justify-center items-center px-6 py-3 rounded-full bg-[#0F5F3F] text-white text-sm font-semibold hover:bg-[#0a4c32]"
        data-testid="newsletter-submit-btn"
      >
        {t("newsletter.submit")}
      </button>
    </form>
  );
}
